import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import {
  Text,
  Card,
  IconEdit,
  Space,
  IconDelete,
  IconSetAsDefault,
  Divider,
  IconButton,
} from '@redlink/components/atoms';
import { ThemeItemThumbnale, Button } from '@redlink/components/molecules';
import { useLocale } from '@redlink/assets/locale';

export const ThemeItem = memo(
  ({
    item: { id, title, palette, createdBy },
    onPress,
    style,
    onEditPress,
    onSetAsDefaultPress,
    onDeletePress,
  }) => {
    const { styles, themeId, colors } = useStyle();
    const { dictionary } = useLocale();
    const isSelected = id === themeId;
    const isCreateByUser = createdBy === 'user';
    return (
      <Card style={[styles.container, style]}>
        <View>
          <ThemeItemThumbnale {...{ palette }} />
        </View>
        <View style={styles.footerContainer}>
          <Text style={styles.title}>{title}</Text>
          <Divider color={colors.gray22} margin={8} />
          <View style={styles.actionsContainers}>
            <IconButton
              disabled={!isCreateByUser}
              style={styles.actionButton}
              onPress={onEditPress}
            >
              <IconEdit color={colors.black} />
            </IconButton>
            <Divider color={colors.gray22} margin={20} horizontal={false} />
            <IconButton
              disabled={!isCreateByUser}
              style={styles.actionButton}
              onPress={onDeletePress}
            >
              <IconDelete color={colors.black} />
            </IconButton>
          </View>
          <Space size={8} />
          <Button
            disabled={isSelected}
            variant={isSelected ? 'greenGlass' : 'blueGlass'}
            title={
              isSelected ? dictionary.defaultTheme : dictionary.setAsDefault
            }
            icon={<IconSetAsDefault color={colors.white} />}
            onPress={onSetAsDefaultPress}
          />
        </View>
      </Card>
    );
  }
);

const useStyle = createUseStyle(({ colors, shadow, size }) => ({
  container: {
    padding: 0,
  },
  title: {
    fontSize: 16,
    color: colors.gray23,
    fontWeight: 'bold',
    flex: 1,
  },
  footerContainer: {
    paddingHorizontal: 16,
    marginTop: 8,
    marginBottom: 16,
  },
  actionsContainers: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  actionButton: {
    backgroundColor: colors.transparent,
  },
}));
